import useLocalStore from '../../../hooks/useLocalStore';
import FJHeaderPanel from './FJHeaderPanel';
import { useMemo, useCallback } from 'react';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJAppConstant from '../../../constants/FJAppConstant.js';
import PropTypes from 'prop-types';
import FJConfig from '../../../config/FJConfig.js';
import { useDispatch, useSelector } from 'react-redux';
import FJActionCommunity from '../../../redux/action/FJActionCommunity.js';
import FJConstant from '../../../constants/FJConstant.js';
const FJHeaderContainer = props => {
    useLocalStore();
    const { appType } = props;
    const dispatch = useDispatch();
    const guestUserInfo = useSelector(state => state.community.guestUserInfo);
    const curLanguage = FJLocalStore.currentTag();
    const isAICommunity = appType === FJAppConstant.AI_COMMUNITY;
    const logoHrefUrl = useMemo(() => {
        if (FJConfig.isRelease) {
            return `https://www.flexclip.com/${curLanguage === 'en' ? '' : curLanguage + '/'}ai/home/`;
        } else {
            return `https://www.smartvideomaker.com/${curLanguage === 'en' ? '' : curLanguage + '/'}apply/home/`;
        }
    }, [curLanguage]);

    const _onLogoClick = useCallback(() => {
        if (isAICommunity) {
            if (guestUserInfo.guestMode) {
                location.href = logoHrefUrl;
            } else {
                dispatch(FJActionCommunity.changeNavBarTabAction(FJConstant.HOME));
            }
        } else {
            location.href = logoHrefUrl;
        }
    }, [isAICommunity, logoHrefUrl, guestUserInfo, dispatch]);
    const _onCommunityClick = useCallback(() => {
        window.open(logoHrefUrl, '_blank');
    }, [logoHrefUrl]);

    return (
        <FJHeaderPanel hideDropdown={isAICommunity} onLogoClick={_onLogoClick} onCommunityClick={_onCommunityClick} />
    );
};

export default FJHeaderContainer;
FJHeaderContainer.propTypes = {
    appType: PropTypes.string.isRequired,
};
